export default "__VITE_ASSET__BjCJ7MDD__"